import { api } from "./client";

export async function generateReport(data: { companyId?: number; type: string; companyIds?: number[] }) {
  return api.post("reports/generate", { json: data }).json<{ report: Record<string, unknown> }>();
}

export async function getReports(params?: { companyId?: number; type?: string; page?: number }) {
  const searchParams = new URLSearchParams();
  if (params?.companyId) searchParams.set("companyId", String(params.companyId));
  if (params?.type) searchParams.set("type", params.type);
  if (params?.page) searchParams.set("page", String(params.page));
  return api.get("reports", { searchParams }).json<{ reports: Record<string, unknown>[] }>();
}

export async function getReport(id: number) {
  return api.get(`reports/${id}`).json<{ report: Record<string, unknown> }>();
}

export async function deleteReport(id: number) {
  return api.delete(`reports/${id}`).json();
}
